import { gql } from '../../../apollo/__generated__';

export const CREATE_PLACE = gql(`
  mutation CreatePlace($createPlaceInput: CreatePlaceInput!) {
    createPlace(createPlaceInput: $createPlaceInput) {
      id
      name
      address
      bedrooms {
        id
        floor
        doorNumber
        maxUsers
      }
    }
  }
`);
